<template>
  <Subdivisions />
</template>

<script>
import Subdivisions from '@/components/admin/Subdivisions.vue'

export default {
  name: 'AdministrationSubdivisions',
  components: { Subdivisions }
}
</script>

<style scoped>

</style>
